import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer } from "react-toastify"
import { useHistory } from "react-router-dom"
import axios from "axios"
import { URLS } from "../../Url"
import classnames from "classnames"

function State() {
  const [forms, setforms] = useState([])
  const [logo, setlogo] = useState([])
  const [Doc, setDoc] = useState([])
  const [fac, setfac] = useState([])

  useEffect(() => {
    GetOneActins()
  }, [])

  const [activeTab1, setactiveTab1] = useState("5")
  const toggle1 = tab => {
    if (activeTab1 !== tab) {
      setactiveTab1(tab)
    }
  }

  const history = useHistory()

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const Actinid = sessionStorage.getItem("ListingId")

  const GetOneActins = () => {
    const data = {
      id: Actinid,
    }

    var token = datas
    axios
      .post(URLS.GetByIdListing, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setforms(res.data.data)
        setfac(res.data.data.facilityDetails)
        setlogo(res.data.data.businessLogo[0])
        setDoc(res.data.data.serviceImg)
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home" breadcrumbItem="Listing View" />
          <Row>
            <Col md={12}>
              <Button
                onClick={() => history.goBack()}
                className="mb-3  m-1 "
                style={{ float: "right" }}
                color="primary"
              >
                <i className="far fa-arrow-alt-circle-left"></i> Back
              </Button>
            </Col>
          </Row>
          <Card>
            <CardBody>
              <h5 className="text-primary">{forms.listingCode} :-</h5>
              <div className="">
                <Row className="mt-3">
                  <Col
                    md={4}
                    style={{
                      border: "1px #806530 solid",
                    }}
                  >
                    <div className="m-2">
                      <img
                        src={URLS.Base + logo}
                        height="250px"
                        width="100%"
                      ></img>
                    </div>
                  </Col>
                  <Col
                    md={8}
                    style={{
                      borderTop: "1px #806530 solid",
                      borderRight: "1px #806530 solid",
                      borderBottom: "1px #806530 solid",
                    }}
                  >
                    <div>
                      <div>
                        <h4 style={{ color: "black" }} className="pt-4">
                          {forms.name}
                        </h4>
                      </div>
                      <div className="pt-3">
                        <span>
                          <i
                            className="bx bx-map-pin text-danger m-1"
                            style={{ fontSize: "20px" }}
                          ></i>
                          {forms.address}, {forms.state}, {forms.city},
                          {forms.pincode}
                        </span>
                      </div>
                      <div className="pt-3">
                        <span>
                          <i
                            className="bx bx-time text-danger m-1"
                            style={{ fontSize: "20px" }}
                          ></i>
                          {forms.dateEstablished}
                        </span>
                      </div>
                      <h4 style={{ color: "#806530" }} className="pt-3">
                        Business Summary{" "}
                      </h4>
                      <p>{forms.aboutUs}</p>
                    </div>
                  </Col>
                </Row>
              </div>
              <div>
                <Row>
                  <Col md={8}>
                    <div className="mt-5">
                      <Nav pills className="navtab-bg nav-justified">
                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "5",
                            })}
                            onClick={() => {
                              toggle1("5")
                            }}
                          >
                            Over View
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "8",
                            })}
                            onClick={() => {
                              toggle1("8")
                            }}
                          >
                            Photos
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
            <div className="mb-5">
              <TabContent activeTab={activeTab1} className="p-3 text-muted">
                <TabPane tabId="5">
                  <h4 style={{ color: "#806530" }}>Business Summary </h4>
                  <p>{forms.aboutUs}</p>
                  <hr></hr>
                  <h4 style={{ color: "#806530" }}>Address</h4>
                  <p>
                    {forms.address}, {forms.state}, {forms.city},{forms.pincode}
                  </p>
                  <hr></hr>
                  <div>
                    <h5 className="pt-3" style={{ color: "#806530" }}>
                      Contact
                    </h5>
                    <p> {forms.contact} </p>
                  </div>
                  <div className="pt-3">
                    <h5 style={{ color: "#806530" }}>Business Hours</h5>
                    <h6>
                      Open Hours{" "}
                      <span>
                        {forms.openTime} / {forms.closeTime}
                      </span>
                    </h6>
                  </div>
                  <div className="pt-3">
                    <h5 style={{ color: "#806530" }}>Website </h5>
                    <p> {forms.website}</p>
                  </div>
                  <hr></hr>
                  <div className="pt-3">
                    <h5 style={{ color: "#806530" }} className="mb-4">
                      Facilities
                    </h5>
                    {fac.map((data, key) => (
                      <Col md="4" key={key}>
                        <p style={{ color: "black" }}>
                          <span className="bx bx-check-circle"></span>{" "}
                          {data.label}
                        </p>
                      </Col>
                    ))}
                  </div>
                  <hr></hr>
                  <div className="pt-3">
                    <h5 style={{ color: "#806530" }} className="mb-4">
                      Tags
                    </h5>
                    {fac.map((data, key) => (
                      <Button
                        key={key}
                        className="btn-sm m-1"
                        outline
                        style={{ backgroundShadow: "none" }}
                      >
                        # {data.label}
                      </Button>
                    ))}
                  </div>
                  <hr></hr>
                  <div className="pt-3">
                    <h5 style={{ color: "#806530" }}>Social Media </h5>
                    <div className="mb-3 row mt-3">
                      <div className="col-md-12">
                        <div>
                          <p className="text-muted">
                            <i className="fa fa-caret-right font-size-16 align-middle text-primary me-2" />
                            FaceBook:{" "}
                            <a
                              href={forms.facebook}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {forms.facebook}
                            </a>
                          </p>
                        </div>
                        <div>
                          <p className="text-muted">
                            <i className="fa fa-caret-right font-size-16 align-middle text-primary me-2" />
                            Instagram:{" "}
                            <a
                              href={forms.instagram}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {forms.instagram}
                            </a>
                          </p>
                        </div>
                        <div>
                          <p className="text-muted">
                            <i className="fa fa-caret-right font-size-16 align-middle text-primary me-2" />
                            Twitter:{" "}
                            <a
                              href={forms.twitter}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {forms.twitter}
                            </a>
                          </p>
                        </div>
                        <div>
                          <p className="text-muted">
                            <i className="fa fa-caret-right font-size-16 align-middle text-primary me-2" />
                            linkedIn :{" "}
                            <a
                              href={forms.linkedIn}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {forms.linkedIn}
                            </a>
                          </p>
                        </div>
                        <div>
                          <p className="text-muted">
                            <i className="fa fa-caret-right font-size-16 align-middle text-primary me-2" />
                            Youtube :{" "}
                            <a
                              href={forms.youtube}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {forms.youtube}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="6">
                  <h4 style={{ color: "#806530" }}>User Details </h4>
                  <Row>
                    <Col md={6}>
                      <ul className="list-unstyled vstack gap-3 mb-0">
                        {forms.profilePic == "" ? (
                          <>
                            {" "}
                            <img
                              src={URLS.Base + forms.profilePic}
                              height="150px"
                              width="50%"
                            ></img>
                          </>
                        ) : (
                          <>
                            <img src={logo} height="150px" width="50%"></img>
                          </>
                        )}
                        <li>
                          <div className="d-flex mt-3">
                            <i className="bx bx-user font-size-18 text-primary"></i>
                            <div className="ms-3">
                              <h6 className="mb-1 fw-semibold">Name:</h6>
                              <span className="text-muted">{forms.name}</span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="d-flex  mt-3">
                            <i className="bx bx-message-rounded font-size-18 text-primary"></i>
                            <div className="ms-3">
                              <h6 className="mb-1 fw-semibold">Email :</h6>
                              {forms.email}
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="d-flex  mt-3">
                            <i className="bx bx-phone font-size-18 text-primary"></i>
                            <div className="ms-3">
                              <h6 className="mb-1 fw-semibold">
                                Contact Number:
                              </h6>
                              {forms.phone}
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="d-flex mt-3">
                            <i className="bx bx-area font-size-18 text-primary"></i>
                            <div className="ms-3">
                              <h6 className="mb-1 fw-semibold">
                                Business Type:
                              </h6>
                              <span className="text-muted">
                                {" "}
                                {forms.vendor == false ? (
                                  <>{"individual"}</>
                                ) : (
                                  <></>
                                )}
                              </span>
                            </div>
                          </div>
                        </li>
                      </ul>{" "}
                    </Col>
                    <Col md={6}>
                      <ul className="list-unstyled vstack gap-3 mb-0">
                        <li>
                          <div className="d-flex mt-3">
                            <i className="bx bx-area font-size-18 text-primary"></i>
                            <div className="ms-3">
                              <h6 className="mb-1 fw-semibold">Community:</h6>
                              <span className="text-muted">
                                {forms.community}
                              </span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="d-flex mt-3">
                            <i className="bx bx-area font-size-18 text-primary"></i>
                            <div className="ms-3">
                              <h6 className="mb-1 fw-semibold">Address:</h6>
                              <span className="text-muted">
                                {forms.address}
                              </span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="d-flex mt-3">
                            <i className="bx bx-area font-size-18 text-primary"></i>
                            <div className="ms-3">
                              <h6 className="mb-1 fw-semibold">
                                Date Of Birth:
                              </h6>
                              <span className="text-muted">
                                {forms.dateOfBirth}
                              </span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="d-flex mt-3">
                            <i className="bx bx-wallet-alt font-size-18 text-primary"></i>
                            <div className="ms-3">
                              <h6 className="mb-1 fw-semibold">Wallet:</h6>
                              <span className="text-muted">{forms.wallet}</span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="d-flex  mt-3">
                            <i className="bx bx-broadcast font-size-18 text-primary"></i>
                            <div className="ms-3">
                              <h6 className="mb-1 fw-semibold">Status :</h6>
                              <span className="badge bg-success">
                                {forms.vendor == false ? (
                                  <>{"Active"}</>
                                ) : (
                                  <>{"InActive"}</>
                                )}
                              </span>
                            </div>
                          </div>
                        </li>
                      </ul>{" "}
                    </Col>
                  </Row>
                  <h4 style={{ color: "#806530" }} className="mt-5">
                    {" "}
                    Documents
                  </h4>
                  <Row>
                    {Doc.map((data, key) => (
                      <Col md="4" key={key} className="mt-5">
                        <img
                          src={URLS.Base + data}
                          height="300px"
                          width="100%"
                        ></img>
                      </Col>
                    ))}
                  </Row>
                </TabPane>
                <TabPane tabId="8">
                  <h4 style={{ color: "#806530" }}>Photos </h4>
                  <Row>
                    {Doc.map((data, key) => (
                      <Col md="4" key={key} className="mt-5">
                        <img
                          src={URLS.Base + data}
                          height="300px"
                          width="100%"
                        ></img>
                      </Col>
                    ))}
                  </Row>
                </TabPane>
              </TabContent>
            </div>
          </Card>
        </Container>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default State
